import { type ModelTimestamp } from "@doitintl/models-any";

import { type Insight } from "../../../Pages/Insights/types";
import { calculateSavings, totalPotentialDailySavings } from "../../../Pages/Insights/utils";
import { getDatetimeAndDiffFromTimestamp } from "../../../utils/time";

export const getInsightPotencialSavings = (insight: Insight) => {
  const potentialDailySavings = totalPotentialDailySavings(insight);
  const potentialSavings = calculateSavings(potentialDailySavings || 0);

  return potentialSavings;
};

export const getTotalPotentialSavings = (insights: Insight[]) =>
  insights?.reduce((acc, insight) => acc + getInsightPotencialSavings(insight), 0);

export const getUtilizationProgressBarColor = (currentUsage: number) => {
  if (currentUsage >= 100) {
    return "error.light";
  } else if (currentUsage > 80) {
    return "warning.main";
  } else if (currentUsage > 50) {
    return "warning.light";
  }
  return "success.light";
};

export const getTimeText = (currentUsage: number, timeWhenTotalAmountExceeded: ModelTimestamp | undefined) => {
  if (!timeWhenTotalAmountExceeded) {
    return "";
  }

  let timeText = "";
  if (currentUsage >= 100) {
    const timeAgo = getDatetimeAndDiffFromTimestamp(timeWhenTotalAmountExceeded).timeAgo;
    timeText = `Budget total hit ${timeAgo}`;
  } else {
    const timeAgo = getDatetimeAndDiffFromTimestamp(timeWhenTotalAmountExceeded).timeAgo;
    timeText = `Budget total due to hit in ${timeAgo.replace(" ago", "")}`;
  }

  return timeText;
};
